var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-loader"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","pulse":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }